import React from "react";
import toast, { Toast as HotToast } from "react-hot-toast";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import "../../styles/toast-premium.css";

type ToastType = "success" | "error" | "loading" | "custom";

const toastMeta: Record<
  ToastType,
  { label: string; icon: React.ReactNode; className: string }
> = {
  success: {
    label: "Success",
    icon: <CheckCircleOutlineRoundedIcon fontSize="small" />,
    className: "premium-toast--success",
  },
  error: {
    label: "Error",
    icon: <ErrorOutlineRoundedIcon fontSize="small" />,
    className: "premium-toast--error",
  },
  loading: {
    label: "Loading",
    icon: <InfoOutlinedIcon fontSize="small" />,
    className: "premium-toast--default",
  },
  custom: {
    label: "Notice",
    icon: <InfoOutlinedIcon fontSize="small" />,
    className: "premium-toast--default",
  },
};

interface PremiumToastProps {
  t: HotToast;
  message: string;
  type: ToastType;
}

export const PremiumToast: React.FC<PremiumToastProps> = ({
  t,
  message,
  type,
}) => {
  const meta = toastMeta[type] ?? toastMeta.success;

  return (
    <div
      className={`premium-toast ${meta.className} ${
        t.visible ? "premium-toast--enter" : "premium-toast--exit"
      }`}
      role="alert"
    >
      <div className="premium-toast-icon">{meta.icon}</div>
      <div className="premium-toast-body">
        <span className="premium-toast-label">{meta.label}</span>
        <p className="premium-toast-message">{message}</p>
      </div>
      <button
        type="button"
        className="premium-toast-close"
        aria-label="Dismiss notification"
        onClick={() => toast.dismiss(t.id)}
      >
        ×
      </button>
    </div>
  );
};

export default PremiumToast;
